import React, { useRef } from "react";
import { get } from "lodash";

const WordDocumentComponent = ({ getBooksVocab, vocType }) => {
    const contentRef = useRef();

    const handleDownload = () => {
        const createWordDocument = async () => {
            try {
                const { saveAs } = await import('file-saver');
                const { Document, Packer, Paragraph, Table, TableRow, TableCell, TextRun, WidthType, AlignmentType } = await import('docx');
                const headerCells = vocType ? [
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Word", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Translation", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Definition", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Synonyms in Spanish", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Synonyms in English", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Antonyms in Spanish", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Antonyms in English", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Sentence in Spanish", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Sentence in English", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    })
                ] : [
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Word", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Translation", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                            children: [new Paragraph({ children: [new TextRun({ text: "Definition", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Synonyms", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Antonyms", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Sentence", bold: true, color: "ffffff", font: "Arial", size: 8, whiteSpace: "nowrap" })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    })
                ];

                // Create data rows with simple styling
                const dataRows = getBooksVocab.map((value, index) => {
                    const data = get(value, 'data', '');
                    // console.log(`Row ${index} data:`, data);
                    const isEvenRow = index % 2 === 1;
                    const rowBg = isEvenRow ? 'f9f9f9' : 'ffffff';
                    
                    if (vocType) {
                        return new TableRow({
                            children: [
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'word') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'english_translation') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'definition') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'synonyms_in_spanish') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'synonyms_in_english') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'antonyms_in_spanish') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'antonyms_in_english') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'sentence_in_spanish') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'sentence_in_english') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                })
                            ]
                        });
                    } else {
                        return new TableRow({
                            children: [
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'word') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'english_translation') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'definition') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: Array.isArray(get(data, 'synonyms')) ? get(data, 'synonyms').join(', ') : '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: Array.isArray(get(data, 'antonyms')) ? get(data, 'antonyms').join(', ') : '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                }),
                                new TableCell({ 
                                    children: [new Paragraph({ children: [new TextRun({ text: get(data, 'sentence') || '-', font: "Arial", size: 8 })] })],
                                    shading: { fill: rowBg },
                                    margins: { top: 150, bottom: 150, left: 180, right: 180 }
                                })
                            ]
                        });
                    }
                });

                const table = new Table({
                    rows: [
                        new TableRow({ children: headerCells }),
                        ...dataRows
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    layout: "fixed",
                    columnWidths: vocType ? 
                        [11, 11, 11, 11, 11, 11, 11, 12, 12] : 
                        [16, 16, 16, 16, 16, 20],
                    borders: {
                        top: { style: "single", size: 1, color: "000000" },
                        bottom: { style: "single", size: 1, color: "000000" },
                        left: { style: "single", size: 1, color: "000000" },
                        right: { style: "single", size: 1, color: "000000" },
                        insideHorizontal: { style: "single", size: 1, color: "000000" },
                        insideVertical: { style: "single", size: 1, color: "000000" }
                    }
                });

                // Create document with cross-platform settings for full width
                const doc = new Document({
                    sections: [{
                        properties: {
                            page: {
                                size: {
                                    orientation: "landscape", // Landscape for better table width
                                    width: 11906, // A4 landscape width in DXA
                                    height: 8420  // A4 landscape height in DXA
                                },
                                margin: {
                                    top: 360,     // 0.25 inch - minimal margins
                                    right: 360,   // 0.25 inch
                                    bottom: 360,  // 0.25 inch
                                    left: 360,    // 0.25 inch
                                },
                            },
                        },
                        children: [
                            new Paragraph({
                                children: [new TextRun({ 
                                    text: `Vocabulary List (${getBooksVocab.length} items)`, 
                                    bold: true, 
                                    size: 14,
                                    font: "Arial" // Cross-platform font
                                })],
                                alignment: AlignmentType.CENTER,
                                spacing: { after: 200 } // Space after title
                            }),
                            table
                        ]
                    }]
                });

                const blob = await Packer.toBlob(doc);
                const fileName = 'Vocabulary_List.docx';
                saveAs(blob, fileName);
                // console.log('File saved:', fileName);
                
            } catch (error) {
                console.error('Error creating Word document:', error);
            }
        };

        createWordDocument();
    };

    return (
        <div>
            <button onClick={handleDownload} style={{ display: 'none' }}>
                Download Word Document
            </button>
        </div>
    );
};

const WordDocumentCognatesComponent = ({ getBooksVocab, vocType }) => {
    const handleDownload = () => {
        const createWordDocument = async () => {
            try {
                const { saveAs } = await import('file-saver');
                const { Document, Packer, Paragraph, Table, TableRow, TableCell, TextRun, WidthType, AlignmentType } = await import('docx');
                const headerCells = [
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Cognate", bold: true, color: "ffffff", font: "Arial", size: 8 })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Word (Spanish)", bold: true, color: "ffffff", font: "Arial", size: 8 })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Word (English)", bold: true, color: "ffffff", font: "Arial", size: 8 })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Type", bold: true, color: "ffffff", font: "Arial", size: 8 })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Explanation", bold: true, color: "ffffff", font: "Arial", size: 8 })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 200, right: 200 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Sentence in Spanish", bold: true, color: "ffffff", font: "Arial", size: 8 })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    }),
                    new TableCell({ 
                        children: [new Paragraph({ children: [new TextRun({ text: "Sentence in English", bold: true, color: "ffffff", font: "Arial", size: 8 })] })],
                        shading: { fill: "5d4187" },
                        margins: { top: 150, bottom: 150, left: 180, right: 180 }
                    })
                ];

                // Create data rows with alternating colors and proper styling
                const dataRows = getBooksVocab.map((value, index) => {
                    const data = get(value, 'data', '');
                    const isEvenRow = index % 2 === 1;
                    const rowBg = isEvenRow ? 'f9f9f9' : 'ffffff';
                    
                    return new TableRow({
                        children: [
                            new TableCell({ 
                                children: [new Paragraph({ children: [new TextRun({ text: data?.type ? "✓" : "✗", font: "Arial", size: 8 })] })],
                                shading: { fill: rowBg },
                                margins: { top: 120, bottom: 120, left: 150, right: 150 }
                            }),
                            new TableCell({ 
                                children: [new Paragraph({ children: [new TextRun({ text: get(data, "word_spanish") || "-", font: "Arial", size: 8 })] })],
                                shading: { fill: rowBg },
                                margins: { top: 120, bottom: 120, left: 150, right: 150 }
                            }),
                            new TableCell({ 
                                children: [new Paragraph({ children: [new TextRun({ text: get(data, "word_english") || "-", font: "Arial", size: 8 })] })],
                                shading: { fill: rowBg },
                                margins: { top: 120, bottom: 120, left: 150, right: 150 }
                            }),
                            new TableCell({ 
                                children: [new Paragraph({ children: [new TextRun({ text: data?.type ? "True Cognate" : "False Cognate" || "-", font: "Arial", size: 8 })] })],
                                shading: { fill: rowBg },
                                margins: { top: 120, bottom: 120, left: 150, right: 150 }
                            }),
                            new TableCell({ 
                                children: [new Paragraph({ children: [new TextRun({ text: get(data, "explaination") || "-", font: "Arial", size: 8 })] })],
                                shading: { fill: rowBg },
                                margins: { top: 120, bottom: 120, left: 150, right: 150 }
                            }),
                            new TableCell({ 
                                children: [new Paragraph({ children: [new TextRun({ text: get(data, "sentence_spanish") || "-", font: "Arial", size: 8 })] })],
                                shading: { fill: rowBg },
                                margins: { top: 120, bottom: 120, left: 150, right: 150 }
                            }),
                            new TableCell({ 
                                children: [new Paragraph({ children: [new TextRun({ text: get(data, "sentence_english") || "-", font: "Arial", size: 8 })] })],
                                shading: { fill: rowBg },
                                margins: { top: 120, bottom: 120, left: 150, right: 150 }
                            })
                        ]
                    });
                });

                const table = new Table({
                    rows: [
                        new TableRow({ children: headerCells }),
                        ...dataRows
                    ],
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    layout: "fixed",
                    columnWidths: [6, 12, 12, 10, 22, 19, 19],
                    borders: {
                        top: { style: "single", size: 1, color: "000000" },
                        bottom: { style: "single", size: 1, color: "000000" },
                        left: { style: "single", size: 1, color: "000000" },
                        right: { style: "single", size: 1, color: "000000" },
                        insideHorizontal: { style: "single", size: 1, color: "000000" },
                        insideVertical: { style: "single", size: 1, color: "000000" }
                    }
                });

                // Create document with cross-platform settings for Cognates
                const doc = new Document({
                    sections: [{
                        properties: {
                            page: {
                                size: {
                                    orientation: "landscape", // Landscape for better table width
                                    width: 11906, // A4 landscape width in DXA
                                    height: 8420  // A4 landscape height in DXA
                                },
                                margin: {
                                    top: 360,     // 0.25 inch - minimal margins
                                    right: 360,   // 0.25 inch
                                    bottom: 360,  // 0.25 inch
                                    left: 360,    // 0.25 inch
                                },
                            },
                        },
                        children: [
                            new Paragraph({
                                children: [new TextRun({ 
                                    text: `Cognates List (${getBooksVocab.length} items)`, 
                                    bold: true, 
                                    size: 14,
                                    font: "Arial" // Cross-platform font
                                })],
                                alignment: AlignmentType.CENTER,
                                spacing: { after: 200 } // Space after title
                            }),
                            table
                        ]
                    }]
                });

                const blob = await Packer.toBlob(doc);
                const fileName = 'Cognates_List.docx';
                saveAs(blob, fileName);
                // console.log('File saved:', fileName);
                
            } catch (error) {
                console.error('Error creating Word document:', error);
            }
        };

        createWordDocument();
    };

    return (
        <div>
            <button onClick={handleDownload} style={{ display: 'none' }}>
                Download Word Document
            </button>
        </div>
    );
};

export { WordDocumentComponent, WordDocumentCognatesComponent };
